/**
 * User Facility Endpoints
 **/

export const getUserFacility = '/endpoint/userFacility';
export const setUserFacility = '/user/setFacility/';

/**
 * FAQ
 **/

export const getFaqs = '/endpoint/faq';
export const getFaqResponse = '/endpoint/faq/response/';
